import useAuth from '../../../../hooks/useAuth'
import {useEffect, useState, FC} from 'react'
import {useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {i18n} from '../../../../translate/i18n'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {ContentModalDescriptionIA} from '../../../../components/ContentModalDescriptionIA'
import {Loading} from '../../../../components/Loading/Loading'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {Input} from '../../../../components/Input/Input'
import usePluginSpace from '../../../../hooks/usePluginSpace'

import {GET, POST, PUT} from '../../../../services/api'
import {Button} from '../../../../components/Button/Button'
import ReactLoading from 'react-loading'
import styles from './newCreate.module.css'
import {IndexGrade} from '../../../../components/Modals/Variacoes/Grade/indexGrade'
import {EditVariacao} from '../../../../components/Modals/Variacoes/Variacao/editVariacao'
import uuid from 'react-uuid'
import {EditorQuill} from '../../../../components/EditorQuill/EditorQuill'
import {Notification} from '../../../../components/Notification/Notification'

import Swal from 'sweetalert2'

type ReturnType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
  shortname: string
  order: string
}

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type TemplateType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  typeIntegration: string
  able: boolean | null
}

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
  variationId?: number
}
interface FileWithPreview extends File {
  preview: string
  id: string | number
}

type LocationTypeResponse = {
  id: number
  name: string
  type?: string
  code: string
}

type SelectType = {
  value: string | number
  label: string
}

// interface CustomerGroup {
//   id: number
//   pluginspaceId: number
//   name: string
//   created: string
//   updated: string | null
//   deleted: string | null
// }

// interface GroupResponseData {
//   id: string
//   pluginspaceId: number
//   productId: number
//   customerGroupId: number
//   createdAt: string | null
//   deletedAt: string | null
//   customerGroup: CustomerGroup
// }

const NewCriarProdutosContent: FC = () => {
  const {loginInfo} = useAuth()
  const navigate = useNavigate()
  const {getPluginSpace} = usePluginSpace()
  const [loading, setLoading] = useState(false)
  const [canAlert, setCanAlert] = useState(false)
  const [pluginIA, setPluginIA] = useState('')
  const [showDescriptionIAModal, setShowDescriptionIAModal] = useState(false)
  const [loadingDescIA, setLoadingDescIA] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  // Estados para grupos de clientes (atacado)
  const [isWholeSaler, setIsWholeSaler] = useState(false)
  const [groups, setGroups] = useState<
    {
      created: string
      deleted: string
      id: number
      name: string
      pluginspaceId: number
      updated: string
    }[]
  >([])
  const [groupsAssociated, setGroupsAssociated] = useState<SelectType[]>([])

  const [name, setName] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [technicalSpecification, setTechnicalSpecification] = useState<string>('')
  const [subcategoryId, setSubcategoryId] = useState<string>('0')
  const [markId, setMarkId] = useState<string | null>(null)
  const [measurementId, setMeasurementId] = useState<string>('0')
  const [status, setStatus] = useState<boolean>(true)
  const [order, setOrder] = useState<number>(0)
  const [filesMedidas, setFilesMedidas] = useState<File[]>([])
  const [filesProduto, setFilesProduto] = useState<File[]>([])
  const [weight, setWeight] = useState<number>()
  const [height, setHeight] = useState<number>()
  const [width, setWidth] = useState<number>()
  const [deep, setDeep] = useState<number>()
  const [formatSize, setFormatSize] = useState<string>('square')

  const [grids, setGrids] = useState<GridTypeResponse[]>([])
  const [gradeSelected, setGradeSelected] = useState<{variationId: number; variations: string[]}[]>(
    []
  )

  const [locations, setLocations] = useState<any[]>([])
  const [locationsSelected, setLocationsSelected] = useState<string | null>(null)

  const [isSimpleProduct, setIsSimpleProduct] = useState<boolean>(true)
  const [isVariationProduct, setIsVariationProduct] = useState<boolean>(false)
  const [categories, setCategories] = useState<any[]>([])
  const [listClassification] = useState<any[]>([])
  const [marks, setMarks] = useState<any[]>([])
  const [measurements, setMeasurements] = useState<any[]>([])
  const [price, setPrice] = useState<number>()
  const [promotionalPrice, setPromotionalPrice] = useState<number>()
  const [costPrice, setCostPrice] = useState<number>()
  const [stockType, setStockType] = useState<string>('infinite')
  const [stockQuantity, setStockQuantity] = useState<number>()

  const [showVariacoesModal, setShowVariacoesModal] = useState(false)
  const [showEditVariacao, setShowEditVariacao] = useState(false)
  const [variacaoSelecionada, setVariacaoSelecionada] = useState<any>(null)

  const [variacoesTabela, setVariacoesTabela] = useState<any[]>([])
  const [variacoesComErro, setVariacoesComErro] = useState<string[]>([])

  const [editGradeAgain, setEditGradeAgain] = useState(false)
  const [alarm, setAlarm] = useState(false)
  const [canAlarmDescription, setCanAlarmDescription] = useState(false)

  const [notification, setNotification] = useState<{
    message: string
    type: 'success' | 'error'
    show: boolean
  }>({
    message: '',
    type: 'success',
    show: false,
  })

  const generateClassificationTree = (
    categories: ReturnType[],
    parent: string | null,
    name: string,
    code: string
  ): any => {
    const parentCategory = categories.find((category) => category.code === parent)
    if (parentCategory)
      return `${generateClassificationTree(
        categories,
        parentCategory.parent,
        parentCategory.name,
        parentCategory.code
      )} > [${code}] ${name}`
    else return `[${code}] ${name}`
  }

  const getCategories = async () => {
    try {
      const res = await GET(`/classification`)
      // Categorias por order
      // Validar, está incorreot
      const sortedCategories = res.data.sort((a: ReturnType, b: ReturnType) => {
        const orderA = parseInt(a.order || '0')
        const orderB = parseInt(b.order || '0')
        return orderA - orderB
      })

      sortedCategories.forEach((row: ReturnType) => {
        listClassification.push({
          id: row.id,
          parent: row.parent,
          code: row.code,
          name: generateClassificationTree(sortedCategories, row.parent, row.name, row.code),
        })
      })

      const categories = [
        {
          value: '0',
          select: 'Selecione',
          key: -1,
        },
      ]
      listClassification.forEach((row: any, idx) => {
        categories.push({
          value: row.id,
          select: row.name,
          key: idx,
        })
      })
      setCategories(categories)
    } catch (e) {
      console.log(e)
    }
  }

  const getMarks = async () => {
    try {
      const res = await GET('/mark')
      const marks = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data
        .sort((a: ReturnType, b: ReturnType) => a.name.localeCompare(b.name))
        .forEach((row: ReturnType) => {
          marks.push({
            value: row.id,
            select: row.name,
          })
        })
      setMarks(marks)
    } catch (e) {
      console.log(e)
    }
  }

  const getMeasurements = async () => {
    try {
      const res = await GET('/measurement')
      const measurements = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data
        .sort((a: ReturnType, b: ReturnType) => a.shortname.localeCompare(b.shortname))
        .forEach((row: ReturnType) => {
          measurements.push({
            value: row.id,
            select: row.description,
          })
        })
      setMeasurements(measurements)
    } catch (e) {
      console.log(e)
    }
  }

  const getCustomersGroups = async () => {
    try {
      const thisPluginsSpace = await getPluginSpace(true)
      const isWholeSaler = thisPluginsSpace && thisPluginsSpace.wholeSaler

      if (isWholeSaler) {
        setIsWholeSaler(true)
        const res = await GET('/customer_groups')
        if (res && res.data) {
          setGroups(res.data)
        }
      }
    } catch (error) {
      console.log('Erro ao buscar grupos de clientes:', error)
    }
  }

  const verifyIA = async () => {
    try {
      const templateRes = await GET('/plugintemplate/ia')
      if (templateRes && templateRes.data) {
        templateRes.data.forEach((template: TemplateType) => {
          if (template.pluginconfig) {
            if (
              template.pluginconfig.content &&
              template.pluginconfig.content.able &&
              template.pluginconfig.content.able !== '0'
            ) {
              setPluginIA(template.pluginconfig.content.modelId)
            }
          }
        })
      }
    } catch (error) {
      console.log('Erro ao verificar IA:', error)
    }
  }

  const generateDescriptionIA = async () => {
    setLoadingDescIA(true)
    try {
      if (pluginIA) {
        const result = await POST('structure-correction-ia/converse-structure', {
          prompt:
            description === ''
              ? `Crie a descrição do produto com base no nome que estou passando. Segue o nome: ${name}`
              : `Corrija ou melhore a descrição do produto que estou passando. Segue a descrição: ${description}`,
          modelId: pluginIA,
          systemPrompt: description === '' ? 'Criar o texto' : 'Revisar o texto',
          typeCorrectionStructure:
            description === '' ? 'description-structure' : 'revision-structure',
        })
        if (result && result.message && result.message.data) {
          setDescription(result.message.data)
          setCanAlert(true)
        }
      }
    } catch (e) {
      console.log('Erro ao chamar API IA (Descrição):', e)
    } finally {
      setLoadingDescIA(false)
    }
  }

  const getGrids = async () => {
    try {
      const gridRes = await GET('/grid')
      const newGrids: GridTypeResponse[] = []
      gridRes.data.forEach((grid: GridTypeResponse) => {
        grid.status &&
          newGrids.push({
            id: grid.id,
            name: grid.name,
            variation: grid.variation,
          })
      })
      setGrids(newGrids)
    } catch (e) {
      console.log(e)
    }
  }

  const getLocations = async () => {
    try {
      const locationRes = await GET('/location')
      let newLocations: any[] = []

      let selectedLocationId: string | null = null

      locationRes.data.forEach((location: LocationTypeResponse) => {
        if (location.type !== 'address') {
          newLocations.push({
            value: location.id,
            select: location.name,
          })
        }
        if (location.type !== 'address' && location.code === 'withdraw')
          selectedLocationId = location.id.toString()
      })
      setLocations(newLocations)

      if (selectedLocationId) setLocationsSelected(selectedLocationId)
    } catch (e) {
      console.log(e)
    }
  }

  // Função para identificar o tipo de grade
  const identifyGradeType = (gradeName: string): 'color' | 'size' | 'unknown' => {
    const colorKeywords = ['cor', 'coloração', 'cores', 'tonalidade', 'color', 'colours', 'colors']
    const sizeKeywords = ['tam', 'tamanho', 'tamanhou', 'size', 'sizes', 'tamanhos']

    const normalizedName = gradeName.toLowerCase().trim()

    // Verifica se o nome contém alguma palavra-chave de cor
    if (colorKeywords.some((keyword) => normalizedName.includes(keyword))) {
      return 'color'
    }

    // Verifica se o nome contém alguma palavra-chave de tamanho
    if (sizeKeywords.some((keyword) => normalizedName.includes(keyword))) {
      return 'size'
    }

    return 'unknown'
  }

  // Função para propagar imagem para variações da mesma cor
  const propagateImageToColorVariations = async (
    image: string,
    colorName: string,
    variations: any[],
    gradeSelected: {variationId: number; variations: string[]}[]
  ) => {
    // Encontra a grade de cor
    const colorGrade = gradeSelected.find(
      (grade) => identifyGradeType(findNameGrade(grade) || '') === 'color'
    )
    if (!colorGrade) return false

    // Encontra a grade de tamanho
    const sizeGrade = gradeSelected.find(
      (grade) => identifyGradeType(findNameGrade(grade) || '') === 'size'
    )
    if (!sizeGrade) return false

    // Filtra as variações que pertencem à mesma cor
    // const colorVariations = variations.filter((variation) => {
    //   const colorValue = variation.context.find(
    //     (ctx: any) => ctx.cod_desc === findNameGrade(colorGrade)
    //   )?.value
    //   return colorValue === colorName
    // })

    // Atualiza as imagens das variações da mesma cor
    const updatedVariations = variations.map((variation) => {
      const colorValue = variation.context.find(
        (ctx: any) => ctx.cod_desc === findNameGrade(colorGrade)
      )?.value

      if (colorValue === colorName) {
        return {
          ...variation,
          img: image,
        }
      }
      return variation
    })

    return updatedVariations
  }

  const findNameGrade = (itemSelected: any) => {
    return grids.find((grade) => grade.id === itemSelected.variationId)?.name
  }

  const processImageWithAPI = async (file: File, width: number, height: number) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('width', width.toString())
      formData.append('height', height.toString())

      const response = await POST('product/process-image_v2', formData)

      if (response.success) {
        const base64String = response.data.file.image

        // Remove o prefixo 'data:image/jpeg;base64,'
        const base64Data = base64String.replace(/^data:image\/\w+;base64,/, '')
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i))
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], {type: response.data.file.type})

        return new File([blob], response.data.file.name, {type: response.data.file.type})
      } else {
        throw new Error(response.error || 'Erro ao processar imagem')
      }
    } catch (error) {
      console.error('Erro ao processar imagem:', error)
      throw error
    }
  }

  const verifyImages = async (filesToVerify: File[]) => {
    const processedFiles: FileWithPreview[] = []
    const requiredWidth = formatSize === 'square' ? 640 : 600
    const requiredHeight = formatSize === 'square' ? 640 : 900

    for (const file of filesToVerify) {
      try {
        const processedFile = await processImageWithAPI(file, requiredWidth, requiredHeight)
        processedFiles.push(
          Object.assign(processedFile, {
            preview: URL.createObjectURL(processedFile),
            id: uuid(),
          })
        )
      } catch (error) {
        console.error('Erro ao processar imagem:', error)
      }
    }

    return processedFiles || filesToVerify
  }

  function limparHTML(html: string): string {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html
    return tempDiv.textContent || ''
  }

  const generateSKU = () => {
    const possible = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
    let text = ''
    for (let i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    text += Date.now().toString().slice(-4)
    return text
  }

  const generateNumericCode = () => {
    return Math.floor(100000 + Math.random() * 900000)
  }

  const uploadImgGuide = async (img: any) => {
    try {
      if (img.length <= 0) return null

      const requiredWidth = formatSize === 'square' ? 640 : 600
      const requiredHeight = formatSize === 'square' ? 640 : 900

      const processedFile = await processImageWithAPI(img[0], requiredWidth, requiredHeight)

      const formData = new FormData()
      formData.append('file', processedFile)
      formData.append('nameImage', `guide-${uuid()}.jpg`)
      const imgRes = await POST('/upload-images/upload-one', formData)

      return imgRes
    } catch (error) {
      return {
        success: false,
        image: '',
      }
    }
  }

  const createProduct = async () => {
    const subcategorySelected: any = subcategoryId
    try {
      if (
        !name ||
        // eslint-disable-next-line eqeqeq
        subcategoryId == '0' ||
        !limparHTML(description) ||
        price === undefined ||
        price === 0
      ) {
        setCanAlert(true)
        setAlarm(true)
        setCanAlarmDescription(true)
        setLoading(false) // Remove loading em caso de erro de validação
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      } else {
        setAlarm(false)
        setCanAlarmDescription(false)
        // Loading já foi iniciado no botão para produtos simples
        // Para variações, é iniciado em checkVariations
        const data = {
          name: name,
          description: description,
          order: order || 0,
          code: generateNumericCode(),
          classificationId: parseInt(subcategorySelected.value),
          type: 'product',
          status: status,
          measurementUnitId: measurementId !== '0' ? parseInt(measurementId) : null,
          parent: '',
          markId: markId ? parseInt(markId) : null,
          technicalSpecification: technicalSpecification,
          // imgGuide: filesMedidas[0].type,
        }

        const resProd = await POST('/product/v2', data)

        // const resProd = {success: true, dados: {id: 1}}
        if (resProd.success === true) {
          let imageRes = {
            success: false,
            image: '',
          }

          let imageGuide = {
            success: false,
            image: '',
          }

          imageGuide = filesMedidas.length > 0 ? await uploadImgGuide(filesMedidas) : imageGuide

          let processedFiles: FileWithPreview[] = []

          if (filesProduto.length > 0) {
            processedFiles = await verifyImages(filesProduto)
            const formData = new FormData()
            formData.append('file', processedFiles[0])
            formData.append('nameImage', `product-${uuid()}.jpg`)
            imageRes = await POST('/upload-images/upload-one', formData)
          }

          if (imageRes.success || imageGuide?.success) {
            const data = [
              ...(imageRes.success === true
                ? [
                    {
                      path: imageRes.image,
                      productId: resProd.dados.id,
                      typeimg: 'imgsmall',
                      order: 0,
                    },
                    {
                      path: imageRes.image,
                      productId: resProd.dados.id,
                      typeimg: 'mainpicture',
                      order: 0,
                    },
                    {
                      path: imageRes.image,
                      productId: resProd.dados.id,
                      typeimg: 'thumbpicture',
                      order: 0,
                    },
                  ]
                : []),
              ...(imageGuide?.success === true
                ? [
                    {
                      path: imageGuide.image,
                      productId: resProd.dados.id,
                      typeimg: 'guide',
                      order: 0,
                    },
                  ]
                : []),
            ]

            if (processedFiles.length > 1) {
              processedFiles.shift()
              await Promise.all(
                Array.from(processedFiles).map(async (image, index) => {
                  let imageExtraRes = {
                    success: false,
                    image: '',
                  }
                  const formData = new FormData()
                  formData.append('file', image)
                  formData.append('nameImage', `product-${uuid()}.jpg`)
                  imageExtraRes = await POST('/upload-images/upload-one', formData)
                  console.log('index:', index)
                  if (imageExtraRes.success === true) {
                    data.push({
                      path: imageExtraRes.image,
                      productId: resProd.dados.id,
                      typeimg: 'image',
                      order: index,
                    })
                  }
                })
              )
            }
            await POST('/productimage/multiple', {
              data,
            })
          }

          // Salvar grupos de clientes se for atacado
          if (isWholeSaler && groupsAssociated.length > 0) {
            await POST('/product-customer-group', {
              productId: resProd.dados.id,
              customerGroups: groupsAssociated.map((group) => group.value),
            })
          }

          setCanAlert(false)
          if (resProd.success && isVariationProduct) {
            // Para variações, chama createVariation que vai controlar o loading
            resProd.dados.id && createVariation(resProd.dados.id)
          } else if (resProd.success && isSimpleProduct) {
            setLoading(false)
            Swal.fire({
              icon: 'success',
              title: 'Produto cadastrado',
              text: 'Produto cadastrado com sucesso!',
            }).then(() => {
              navigate(loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion')
            })
          }
        } else {
          setCanAlert(true)
          setLoading(false) // Remove loading em caso de erro
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar o produto!',
          })
        }
      }
    } catch (e) {
      setCanAlert(true)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao cadastrar o produto!',
      })
      // Remove loading em caso de erro, independente do tipo
      setLoading(false)
    }
  }

  const checkVariations = async () => {
    try {
      const variacoesErro: string[] = []
      variacoesTabela.forEach((variation: any) => {
        if (!variation.locationId || !variation.sku || !variation.price) {
          variacoesErro.push(variation.id)
        }
      })
      setVariacoesComErro(variacoesErro)

      if (variacoesErro.length > 0) {
        setLoading(false) // Remove loading em caso de erro de validação das variações
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos obrigatórios nas variações!',
        })
        return
      }

      // Loading já foi iniciado no botão de salvar
      createProduct()
    } catch (error) {
      console.log(error)
      setLoading(false) // Remove loading em caso de erro
    }
  }

  const createVariation = async (productId: string) => {
    try {
      // Loading já foi iniciado em checkVariations, não precisa reiniciar

      // Adiciona o productId em cada variação
      const variacoesComProductId = variacoesTabela.map(({id, ...rest}) => ({
        ...rest,
        productId: Number(productId),
        locationId: Number(rest.locationId),
        price:
          typeof rest.price === 'string'
            ? parseFloat(rest.price.replace(/[R$\s.]/g, '').replace(',', '.'))
            : rest.price,
        costPrice: rest.costPrice
          ? typeof rest.costPrice === 'string'
            ? parseFloat(rest.costPrice.replace(/[R$\s.]/g, '').replace(',', '.'))
            : rest.costPrice
          : 0,
        promotionalPrice: rest.promotionalPrice
          ? typeof rest.promotionalPrice === 'string'
            ? parseFloat(rest.promotionalPrice.replace(/[R$\s.]/g, '').replace(',', '.'))
            : rest.promotionalPrice
          : 0,
        inventory: stockType === 'infinite' ? 10000 : Number(rest.inventory),
        minimumStock: rest.minimumStock ? Number(rest.minimumStock) : 0,
        width: rest.width ? Number(rest.width) : 0,
        height: rest.height ? Number(rest.height) : 0,
        weight: rest.weight ? Number(rest.weight) : 0,
        depth: rest.depth ? Number(rest.depth) : 0,
        status: Boolean(rest.status),
        stockSituation: rest.productAvailability ? Number(rest.productAvailability) : null,
        outOfStockSituation: rest.productOutOfStock ? Number(rest.productOutOfStock) : null,
        context: JSON.stringify(
          rest.context.reduce((acc: any, item: {cod_desc: string; value: any}) => {
            acc[item.cod_desc] =
              typeof item.value === 'object' && item.value !== null ? item.value.value : item.value
            return acc
          }, {})
        ),
        img: rest.img ? rest.img : '',
      }))

      // Cria as variações
      const variationsRes = await POST('/variations/multiple', {
        data: variacoesComProductId,
      })

      if (variationsRes.success === true) {
        // Salva as imagens das variações (sem controlar loading internamente)
        const imgResult = await saveImgVariations(variacoesComProductId, variationsRes)

        if (imgResult.success) {
          setCanAlert(false)
          await Swal.fire({
            icon: 'success',
            title: 'Produtos cadastrados',
            text: 'Cadastro realizado com sucesso!',
          })

          navigate(loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion')
        } else {
          console.error('Erro ao salvar imagens:', imgResult.error)
          setCanAlert(true)
          await Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao salvar imagens das variações!',
          })
        }
      } else {
        setCanAlert(true)
        await Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao cadastrar os produtos!',
        })
      }
    } catch (e) {
      console.error('Erro na criação de variações:', e)
      setCanAlert(true)
      await Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao cadastrar os produtos!',
      })
    } finally {
      // Garante que o loading será sempre removido no final
      setLoading(false)
    }
  }

  const saveImgVariations = async (variacoesComProductId: any, variationsRes: any) => {
    try {
      // Esta função não controla loading - deixa para createVariation controlar
      // Evita piscar de loading durante o processo de salvar imagens
      await Promise.all(
        variacoesComProductId.map(async (variacao: any, index: any) => {
          if (variacao.img) {
            const variationId = variationsRes.dados.identifiers[index].id
            await PUT(`/variations/${variationId}`, {
              img: variacao.img,
            })
          }
        })
      )
      return {success: true}
    } catch (error) {
      console.error('Erro ao salvar imagens de variações:', error)
      return {success: false, error}
    }
  }

  const handleUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = true
  }

  const handleRemoveVariation = (variationId: number, variationSelected: string) => {
    Swal.fire({
      title: 'Atenção!',
      text: `Ao deletar "${variationSelected}", as variações já editadas serão redefinidas.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setGradeSelected((prev) =>
          prev
            .map((grade) =>
              grade.variationId === variationId
                ? {
                    ...grade,
                    variations: grade.variations.filter((v) => v !== variationSelected),
                  }
                : grade
            )
            .filter((grade) => grade.variations.length > 0)
        )
      }
    })
  }

  // Função para criar as combinações de variações
  function createVariations(arrays: string[][]): string[][] {
    return arrays.reduce(
      (a, b) => a.map((x) => b.map((y) => x.concat([y]))).reduce((a, b) => a.concat(b), []),
      [[]] as string[][]
    )
  }

  useEffect(() => {
    if (gradeSelected.length > 0) {
      const variationsArrays = gradeSelected.map((grade) => grade.variations)
      const combinations = createVariations(variationsArrays)
      const nomesGrades = gradeSelected.map((grade) => findNameGrade(grade))

      setVariacoesTabela((prevVariacoesTabela) => {
        const updatedVariacoes = combinations.map((comb) => {
          const name = comb.join(' ')
          const existingVariation = prevVariacoesTabela.find((v) => v.name === name)

          return {
            id: existingVariation?.id || uuid(),
            name: name,
            context: comb.map((value, index) => ({
              cod_desc: nomesGrades[index],
              value: value,
            })),
            inventory:
              existingVariation?.inventory ||
              (stockType === 'infinite' ? '∞' : stockQuantity ? stockQuantity : '0'),
            price:
              existingVariation?.price ||
              (price
                ? `${price.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`
                : 0),
            costPrice:
              existingVariation?.costPrice ||
              (costPrice
                ? `${costPrice.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`
                : 0),
            promotionalPrice:
              existingVariation?.promotionalPrice ||
              (promotionalPrice
                ? `${promotionalPrice.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}`
                : 0),
            height: existingVariation?.height || (height ? height : 0),
            width: existingVariation?.width || (width ? width : 0),
            depth: existingVariation?.depth || (deep ? deep : 0),
            weight: existingVariation?.weight || (weight ? weight : 0),
            minimumStock: existingVariation?.minimumStock || '',
            productAvailability: existingVariation?.productAvailability || '',
            productOutOfStock: existingVariation?.productOutOfStock || '',
            locationId:
              existingVariation?.locationId || (locationsSelected ? locationsSelected : ''),
            sku: existingVariation?.sku || generateSKU(),
            referenceCode: existingVariation?.referenceCode || '',
            gtin: existingVariation?.gtin || '',
            mpn: existingVariation?.mpn || '',
            ncm: existingVariation?.ncm || '',
            status: existingVariation?.status !== undefined ? existingVariation.status : true,
            img: existingVariation?.img || '',
          }
        })
        return updatedVariacoes
      })
    } else {
      setVariacoesTabela([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    gradeSelected,
    stockType,
    stockQuantity,
    price,
    costPrice,
    promotionalPrice,
    height,
    width,
    deep,
    weight,
    locationsSelected,
  ])

  const handleSaveVariacao = async (variacaoEditada: any, propagateImage: boolean = false) => {
    if (propagateImage && variacaoEditada.img) {
      // Encontra a grade de cor
      const colorGrade = gradeSelected.find(
        (grade) => identifyGradeType(findNameGrade(grade) || '') === 'color'
      )
      if (colorGrade) {
        // Encontra o valor da cor na variação editada
        const colorValue = variacaoEditada.context.find(
          (ctx: any) => ctx.cod_desc === findNameGrade(colorGrade)
        )?.value

        if (colorValue) {
          const updatedVariations = await propagateImageToColorVariations(
            variacaoEditada.img,
            colorValue,
            variacoesTabela,
            gradeSelected
          )

          if (updatedVariations) {
            setVariacoesTabela(updatedVariations)
          }
        }
      }
    }

    setVariacoesTabela((prev) =>
      prev.map((v) => (v.id === variacaoEditada.id ? variacaoEditada : v))
    )
    setNotification({
      message: 'Variação salva com sucesso!',
      type: 'success',
      show: true,
    })
  }

  useEffect(() => {
    if (showEditVariacao || showVariacoesModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showEditVariacao, showVariacoesModal])

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const init = async () => {
    setLoading(true)
    await verifyIA()
    await getCategories()
    await getMarks()
    await getMeasurements()
    await getGrids()
    await getLocations()
    await getCustomersGroups()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className='row g-5 gx-xxl-12 pb-5'>
            <div className='card'>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-4 mb-1'>
                    {i18n.t(`smart_order.create_product`)}
                  </span>
                  <BreadCrumbs />
                </h3>
              </div>
            </div>

            <div className='card mt-8'>
              <div className='px-10 py-5'>
                <h1 className={styles.sectionTitle}>
                  <i className='bi bi-file-earmark-text'></i>
                  Detalhes do Produto
                </h1>
                <div className='mt-8'>
                  {/* Informações do Produto */}
                  <div className={`${styles.groupTitle} mt-1`}>Informações do Produto</div>

                  <Input
                    inputAttr={{
                      type: 'default',
                    }}
                    placeholder={i18n.t(`smart_order.name`)}
                    label={`${i18n.t(`smart_order.name`)} *`}
                    value={name}
                    change={(value: string) => {
                      setCanAlert(true)
                      setName(value)
                    }}
                    alarm={alarm && !name}
                    alarmText='Campo obrigatório'
                    generateValueIA={
                      pluginIA && pluginIA !== ''
                        ? {
                            modelId: pluginIA,
                            prompt:
                              name === ''
                                ? 'Sugira um nome de produto com base na descrição: ' + description
                                : 'Corrija o nome do produto: ' + name,
                            action: name === '' ? 'create' : 'fix',
                          }
                        : undefined
                    }
                  />
                  <div className='mt-6'>
                    <div className={styles.descriptionHeader}>
                      <label className='form-label fw-normal'>
                        {i18n.t(`smart_order.description`)} *
                      </label>
                    </div>
                    <EditorQuill
                      change={(value: string) => {
                        setCanAlert(true)
                        setDescription(value)
                      }}
                      value={description}
                      alarm={canAlarmDescription && !limparHTML(description)}
                      maxLength={415}
                    />

                    {/* Botão IA Avançada */}
                    {pluginIA && pluginIA !== '' && (
                      <div className='d-flex justify-content-start mt-2'>
                        <Button
                          text='Descrição Avançada com IA'
                          color='primary'
                          size='small'
                          horizontalPadding={3}
                          svgIcon={
                            <svg
                              width='15'
                              height='15'
                              viewBox='0 0 15 15'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                fill='white'
                              />
                            </svg>
                          }
                          btnAttr={{
                            type: 'button',
                          }}
                          click={() => setShowDescriptionIAModal(true)}
                          btnClass='fw-bolder d-flex flex-row gap-1 align-items-center'
                          txtClass='text-nowrap text-white'
                          outline={false}
                          disabled={!name}
                        />
                      </div>
                    )}

                    {canAlarmDescription && !limparHTML(description) && (
                      <div className='d-flex align-items-center border-hover-primary rounded w-100 mt-1'>
                        <span
                          style={{
                            color:
                              canAlarmDescription && !limparHTML(description) ? '#d90429' : 'none',
                          }}
                        >
                          Campo obrigatório
                        </span>
                      </div>
                    )}
                    <div className={styles.descriptionFooter}>
                      <div>
                        {pluginIA && pluginIA !== '' && (
                          <div className='d-flex justify-content-start' style={{maxWidth: '100%'}}>
                            {loadingDescIA ? (
                              <ReactLoading type='spin' color='#D5D5D5' height={25} width={25} />
                            ) : (
                              <Button
                                text={`${i18n.t(`buttons.generate_ia`)} descrição`}
                                color='info'
                                size='small'
                                horizontalPadding={5}
                                btnAttr={{
                                  type: 'button',
                                }}
                                svgIcon={
                                  <svg
                                    width='15'
                                    height='15'
                                    viewBox='0 0 15 15'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                      fill='white'
                                    />
                                  </svg>
                                }
                                click={generateDescriptionIA}
                                btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                                txtClass='text-nowrap'
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='mt-6'>
                      <div>
                        <label className='form-label fw-normal'>
                          {i18n.t(`smart_order.technical_specification`)}
                        </label>
                      </div>
                      <EditorQuill
                        change={(value: string) => {
                          setCanAlert(true)
                          setTechnicalSpecification(value)
                        }}
                        value={technicalSpecification}
                        maxLength={415}
                      />

                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        search
                        label={`${i18n.t(`smart_order.category`)} *`}
                        options={categories}
                        value={subcategoryId}
                        change={(value: string) => {
                          setCanAlert(true)
                          setSubcategoryId(value)
                        }}
                        marginTop='mt-0'
                        alarm={alarm && subcategoryId === '0'}
                        alarmText='Campo obrigatório'
                      />
                    </div>
                  </div>

                  <div className='row g-6'>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label={`${i18n.t(`smart_order.mark`)}`}
                        options={marks}
                        value={markId}
                        change={(value: string) => {
                          setCanAlert(true)
                          setMarkId(value)
                        }}
                      />
                    </div>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label={`${i18n.t(`smart_order.measurement_unit`)}`}
                        options={measurements}
                        value={measurementId}
                        change={(value: string) => {
                          setCanAlert(true)
                          setMeasurementId(value)
                        }}
                      />
                    </div>
                  </div>

                  <div className='row g-6'>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Status'
                        options={[
                          {select: i18n.t(`general.active`), value: true},
                          {select: i18n.t(`general.inactive`), value: false},
                        ]}
                        value={status}
                        change={(value: boolean) => {
                          setCanAlert(true)
                          setStatus(value)
                        }}
                      />
                    </div>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={i18n.t(`smart_order.order`)}
                        smalltext='(para exibição no webapp)'
                        value={order}
                        change={(value: number) => {
                          setCanAlert(true)
                          setOrder(value)
                        }}
                        alarmText='Campo obrigatório'
                      />
                    </div>
                  </div>

                  <div className='mt-6'>
                    <label className={styles.labelImageGuia}>Guia de Medidas</label>
                    <div className={styles.imageUploadContainer}>
                      <div className={styles.inputWrapper}>
                        <input
                          type='file'
                          accept='image/*'
                          onChange={(e) => {
                            setCanAlert(true)
                            if (e.target.files && e.target.files.length > 0) {
                              setFilesMedidas([e.target.files[0]])
                            }
                          }}
                          className={styles.fileInput}
                        />
                        {filesMedidas && filesMedidas.length > 0 ? (
                          <div className={styles.previewImage}>
                            <img
                              src={URL.createObjectURL(filesMedidas[0])}
                              alt='Guia de Medidas'
                              className='w-100 h-100'
                              style={{objectFit: 'cover'}}
                            />
                            <button
                              className={styles.deleteImageButton}
                              onClick={(e) => {
                                e.preventDefault()
                                setFilesMedidas([])
                              }}
                              title='Excluir imagem'
                            >
                              <i className='bi bi-x-lg'></i>
                            </button>
                          </div>
                        ) : (
                          <div className={styles.inputPlaceholder}>
                            <i className='bi bi-card-image'></i>
                            <span>Selecione uma imagem</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Preços */}
                  <div className={`${styles.groupTitle} mt-2`}>Preços</div>
                  <div className='mt-2 row g-6'>
                    <div className='mt-0 col-md-4'>
                      <Input
                        inputAttr={{
                          type: 'money',
                        }}
                        currency='BRL'
                        locale='pt-BR'
                        label={i18n.t(`smart_order.cost_price`)}
                        change={(value: number) => {
                          setCanAlert(true)
                          setCostPrice(value)
                        }}
                        value={costPrice}
                        marginTop='mt-0'
                      />
                    </div>
                    <div className='mt-0 col-md-4'>
                      <Input
                        inputAttr={{
                          type: 'money',
                        }}
                        currency='BRL'
                        locale='pt-BR'
                        label={`${i18n.t(`smart_order.sell_price`)} *`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setPrice(value)
                        }}
                        value={price}
                        marginTop='mt-0'
                        alarm={alarm && (price === undefined || price === 0)}
                        alarmText='Campo obrigatório'
                      />
                    </div>
                    <div className='mt-0 col-md-4'>
                      <Input
                        inputAttr={{
                          type: 'money',
                        }}
                        currency='BRL'
                        locale='pt-BR'
                        label={i18n.t(`smart_order.promotional_price`)}
                        change={(value: number) => {
                          setCanAlert(true)
                          setPromotionalPrice(value)
                        }}
                        value={promotionalPrice}
                        marginTop='mt-0'
                      />
                    </div>
                  </div>

                  {/* Estoque */}
                  <div className={`${styles.groupTitle} mt-6`}>Estoque</div>
                  <div>
                    <div className={`${styles.containerStock}`}>
                      <div className={`d-flex flex-column`}>
                        <div
                          className={`cursor-pointer ${styles.radioItem}`}
                          onClick={() => {
                            setCanAlert(true)
                            setStockType('infinite')
                          }}
                        >
                          <span className={styles.radioLabel}>Infinito</span>
                          <div
                            className={`${styles.radioCircle} ${
                              stockType === 'infinite' ? styles.checked : ''
                            }`}
                          >
                            {stockType === 'infinite' && (
                              <i className={`bi bi-check ${styles.checkIcon}`}></i>
                            )}
                          </div>
                        </div>
                        <div
                          className={`cursor-pointer ${styles.radioItem}`}
                          onClick={() => {
                            setCanAlert(true)
                            setStockType('limited')
                          }}
                        >
                          <span className={styles.radioLabel}>Limitado</span>
                          <div
                            className={`${styles.radioCircle} ${
                              stockType === 'limited' ? styles.checked : ''
                            }`}
                          >
                            {stockType === 'limited' && (
                              <i className={`bi bi-check ${styles.checkIcon}`}></i>
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        className={`${styles.stockLine} ${
                          stockType === 'limited' ? styles.visible : ''
                        }`}
                      >
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          label='Quantidade'
                          value={stockQuantity}
                          change={(value: number) => {
                            setCanAlert(true)
                            setStockQuantity(value)
                          }}
                          placeholder='0'
                          marginTop='mt-0'
                        />

                        <div
                          className={`${styles.stockAlert} ${
                            stockType === 'limited' ? styles.visible : ''
                          }`}
                        >
                          <i className='bi bi-exclamation-triangle-fill'></i>
                          <span>Estoque somente para produtos com variação</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Volumetria */}
                  <div className={`${styles.groupTitle} mt-6`}>Volumetria</div>

                  <div className='mt-2 row g-6'>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.weight`)} (Kg)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setWeight(value)
                        }}
                        value={weight}
                        marginTop='mt-0'
                      />
                    </div>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.height`)} (cm)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setHeight(value)
                        }}
                        value={height}
                        marginTop='mt-0'
                      />
                    </div>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.width`)} (cm)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setWidth(value)
                        }}
                        value={width}
                        marginTop='mt-4'
                      />
                    </div>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.depth`)} (cm)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setDeep(value)
                        }}
                        value={deep}
                        marginTop='mt-4'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Grupos de Clientes para Atacado */}
            {isWholeSaler && (
              <div className='card mt-8'>
                <div className='px-10 py-5'>
                  <h1 className={styles.sectionTitle}>
                    <i className='bi bi-people'></i>
                    {i18n.t(`smart_order.product_groups`)}
                  </h1>
                  <div className='mt-8'>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      isMulti
                      search
                      placeholder={i18n.t(`smart_order.product_groups`)}
                      label={i18n.t(`smart_order.product_groups`)}
                      value={groupsAssociated}
                      change={(selectedGroups: SelectType[]) => {
                        setCanAlert(true)
                        setGroupsAssociated(selectedGroups)
                      }}
                      options={groups.map((row) => {
                        return {
                          value: row.id,
                          select: row.name,
                        }
                      })}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Imagens do produto */}
            <div className='card mt-8 px-0'>
              <div className='px-10 py-5'>
                <h1 className={`${styles.sectionTitle} mb-0`}>
                  <i className='bi bi-images'></i>
                  Imagem Produto
                </h1>
                <div className='mt-6'>
                  <span>Selecione as dimensões</span>
                  <div className='d-flex align-items-center gap-3 mt-2'>
                    <div
                      className={`${styles.checkboxContainer} ${
                        formatSize === 'square' ? styles.checked : ''
                      }`}
                      onClick={() => {
                        setCanAlert(true)
                        setFormatSize('square')
                      }}
                    >
                      <input
                        type='checkbox'
                        checked={formatSize === 'square'}
                        className={styles.checkboxInput}
                      />
                      <span className={styles.checkboxLabel}>Tratar com 640x640</span>
                    </div>
                    <div
                      className={`${styles.checkboxContainer} ${
                        formatSize === 'rectangle' ? styles.checked : ''
                      }`}
                      onClick={() => {
                        setCanAlert(true)
                        setFormatSize('rectangle')
                      }}
                    >
                      <input
                        type='checkbox'
                        checked={formatSize === 'rectangle'}
                        className={styles.checkboxInput}
                      />
                      <span className={styles.checkboxLabel}>Tratar com 600x900</span>
                    </div>
                  </div>
                </div>
                <div className='mt-8'>
                  <Input
                    inputAttr={{type: 'image-upload'}}
                    label='Imagens Produto'
                    change={(newFiles: File[]) => {
                      if (newFiles && newFiles.length > 0) {
                        setCanAlert(true)
                      }
                      setFilesProduto(newFiles)
                    }}
                    iconImage={'bi bi-images'}
                    mainTextImage={'Arraste e solte sua imagem principal e imagens adicionais'}
                    descriptionImage={
                      'Você pode arrastar e soltar as imagens para organizá-las. A imagem que ficar na primeira posição será considerada como a imagem principal.'
                    }
                    sizeImage={`As Imagens devem ter ${
                      formatSize === 'square' ? '640x640' : '600x900'
                    } para melhor visualização.`}
                    dragAndDropImage={true}
                  />
                </div>
              </div>
            </div>

            <Notification
              message={errorMessage}
              type='warning'
              show={!!errorMessage}
              onClose={() => setErrorMessage('')}
              duration={2000}
            />

            <div className='card mt-8'>
              <div className='px-10 py-5'>
                <h1 className={styles.sectionTitle}>
                  <i className='bi bi-grid-3x3-gap'></i>
                  Variação Produto
                </h1>
                <div className='mt-8'>
                  <div className='d-flex gap-4'>
                    <div className='d-flex align-items-center gap-3'>
                      <div
                        className={`${styles.checkboxContainer} ${
                          isSimpleProduct ? styles.checked : ''
                        }`}
                        onClick={() => {
                          setCanAlert(true)
                          if (isVariationProduct) setIsVariationProduct(false)
                          setIsSimpleProduct(true)
                        }}
                      >
                        <input
                          type='checkbox'
                          checked={isSimpleProduct}
                          className={styles.checkboxInput}
                        />
                        <span className={styles.checkboxLabel}>Produto Simples</span>
                      </div>
                    </div>

                    <div className='d-flex align-items-center gap-3'>
                      <div
                        className={`${styles.checkboxContainer} ${
                          isVariationProduct ? styles.checked : ''
                        }`}
                        onClick={() => {
                          setCanAlert(true)
                          if (isSimpleProduct) setIsSimpleProduct(false)
                          setIsVariationProduct(true)
                        }}
                      >
                        <input
                          type='checkbox'
                          checked={isVariationProduct}
                          className={styles.checkboxInput}
                        />
                        <span className={styles.checkboxLabel}>Produto com Variação</span>
                      </div>
                    </div>
                  </div>
                  {!isVariationProduct ? (
                    <div className='mt-8'>
                      <p className='mt-8'>Tipo: {isSimpleProduct ? 'Simples' : 'Com Variação'}</p>
                    </div>
                  ) : (
                    <>
                      <div className={`${styles.groupTitle} mt-6`}>Variações</div>

                      {gradeSelected.length <= 0 && (
                        <div
                          className='d-flex align-items-center gap-2'
                          onClick={() => {
                            setEditGradeAgain(false)
                            setShowVariacoesModal(true)
                          }}
                          style={{cursor: 'pointer'}}
                        >
                          <div className={styles.addButtonCircle}>
                            <i className='fas fa-plus'></i>
                          </div>
                          <h2 className='m-0 fs-5' style={{color: '#009ef7'}}>
                            Adicionar Variações
                          </h2>
                        </div>
                      )}
                      <div className='mt-2'>
                        {gradeSelected.map((grade) => (
                          <div key={grade.variationId} className='mb-3'>
                            <div className='fw-bold mb-2'>{findNameGrade(grade)}</div>
                            <div className='d-flex flex-wrap gap-2'>
                              {grade.variations.map((variation) => (
                                <span key={variation} className={styles.variationChip}>
                                  {variation}
                                  <button
                                    type='button'
                                    className={styles.variationRemove}
                                    onClick={() =>
                                      handleRemoveVariation(grade.variationId, variation)
                                    }
                                  >
                                    <i className={`bi bi-x ${styles.variationRemoveIcon}`}></i>
                                  </button>
                                </span>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                      {variacoesTabela.length > 0 && (
                        <>
                          <div className={styles.tableContainer}>
                            <table className={`${styles.variationTable}`}>
                              <thead>
                                <tr>
                                  <th>Variação</th>
                                  <th>SKU</th>
                                  <th>Estoque</th>
                                  <th>Preço de venda</th>
                                  <th>Status</th>
                                  <th>Ação</th>
                                </tr>
                              </thead>
                              <tbody>
                                {variacoesTabela.map((item) => (
                                  <tr
                                    key={item.id}
                                    style={{
                                      borderLeft: variacoesComErro.includes(item.id)
                                        ? '1px solid red'
                                        : 'none',
                                    }}
                                  >
                                    <td>
                                      <span className={styles.variationName}>
                                        <img
                                          src={
                                            item.img
                                              ? typeof item.img === 'string'
                                                ? item.img
                                                : item.img instanceof File
                                                ? URL.createObjectURL(item.img)
                                                : 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/card-image.svg'
                                              : 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/card-image.svg'
                                          }
                                          alt={item.nome}
                                          className={styles.variationImg}
                                          onClick={() => {
                                            setVariacaoSelecionada(item)
                                            setShowEditVariacao(true)
                                          }}
                                          style={{cursor: 'pointer'}}
                                        />
                                        {item.name}
                                      </span>
                                    </td>
                                    <td>{item.sku}</td>
                                    <td>
                                      <div style={{width: 60}}>
                                        <input
                                          type='text'
                                          value={item.inventory}
                                          className={styles.variationInput}
                                          onChange={(e) => {
                                            setVariacoesTabela((prev) =>
                                              prev.map((v) =>
                                                v.id === item.id
                                                  ? {...v, inventory: e.target.value}
                                                  : v
                                              )
                                            )
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div style={{width: 100}}>
                                        <Input
                                          inputAttr={{
                                            type: 'money',
                                          }}
                                          currency='BRL'
                                          locale='pt-BR'
                                          change={(e: any) => {
                                            setVariacoesTabela((prev) =>
                                              prev.map((v) =>
                                                v.id === item.id ? {...v, price: e} : v
                                              )
                                            )
                                            if (e) {
                                              setVariacoesComErro((prev) =>
                                                prev.filter((id) => id !== item.id)
                                              )
                                            }
                                          }}
                                          value={item.price}
                                          marginTop='mt-0'
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <label className={styles.switch}>
                                        <input
                                          type='checkbox'
                                          checked={item.status}
                                          onChange={(e) => {
                                            setVariacoesTabela((prev) =>
                                              prev.map((v) =>
                                                v.id === item.id
                                                  ? {...v, status: e.target.checked}
                                                  : v
                                              )
                                            )
                                          }}
                                        />
                                        <span className={styles.slider}></span>
                                      </label>
                                    </td>
                                    <td>
                                      <button
                                        onClick={() => {
                                          setVariacaoSelecionada(item)
                                          setShowEditVariacao(true)
                                        }}
                                        className={styles.actionBtn}
                                        title='Editar Variação'
                                        style={{cursor: 'pointer'}}
                                      >
                                        <i className='fas fa-pen'></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div
                            className={`mt-2 ${styles.editGradesButton}`}
                            onClick={() => {
                              Swal.fire({
                                title: 'Atenção!',
                                text: `Ao realizar esta alteração, todas as variações configuradas anteriormente serão redefinidas. Deseja prosseguir?`,
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Confirmar',
                                cancelButtonText: 'Cancelar',
                                reverseButtons: true,
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  setEditGradeAgain(true)
                                  setShowVariacoesModal(true)
                                }
                              })
                            }}
                          >
                            <i className='fas fa-pen'></i>
                            <span>Editar Grades</span>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className='card mt-8'>
              <div className='px-10 py-5'>
                <div className='d-flex justify-content-between w-100 mt-8'>
                  <Button
                    text={i18n.t(`buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      if (canAlert) {
                        Swal.fire({
                          title: 'Sair da página?',
                          text: 'Há alterações não salvas que serão perdidas se você sair da página.',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Sair',
                          cancelButtonText: 'Continuar editando',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setCanAlert(false)
                            navigate(
                              loginInfo.plugintype === 'varejo'
                                ? '/product_varejo'
                                : '/product_fashion'
                            )
                          }
                        })
                      } else {
                        navigate(
                          loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion'
                        )
                      }
                    }}
                    btnClass='fw-bolder me-3'
                  />
                  <Button
                    text={i18n.t(`buttons.save`)}
                    color='primary'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      setCanAlert(false)
                      // Inicia loading sempre, independente do tipo de produto
                      setLoading(true)
                      isSimpleProduct ? createProduct() : checkVariations()
                    }}
                    btnClass='fw-bolder'
                  />
                </div>
              </div>
            </div>
          </div>

          {showVariacoesModal && (
            <IndexGrade
              onCloseAction={() => {
                setShowVariacoesModal(false)
              }}
              title='Grades'
              grids={grids}
              gradeSelected={gradeSelected}
              setGradeSelected={setGradeSelected}
              editGradeAgain={editGradeAgain}
            />
          )}
          {showEditVariacao && (
            <EditVariacao
              onCloseAction={() => {
                setShowEditVariacao(false)
                setVariacaoSelecionada(null)
              }}
              title='Editar Variação'
              item={variacaoSelecionada}
              onSave={handleSaveVariacao}
              formatSize={formatSize}
              locations={locations}
              setVariacoesComErro={setVariacoesComErro}
            />
          )}
          <Notification
            message={notification.message}
            type={notification.type}
            show={notification.show}
            onClose={() => setNotification((prev) => ({...prev, show: false}))}
          />
        </>
      )}

      {/* Modal IA para Descrição */}
      {showDescriptionIAModal && (
        <ModalWrapper
          confirmAction={() => setShowDescriptionIAModal(false)}
          noCloseOverlay={true}
          noCloseButton={true}
          noAction={true}
          width={70}
          maxWidth
        >
          <ContentModalDescriptionIA
            description={description}
            productName={name}
            productImage={filesProduto.length > 0 ? URL.createObjectURL(filesProduto[0]) : null}
            pluginIA={pluginIA}
            onDescriptionGenerated={(generatedDescription: string) => {
              setDescription(generatedDescription)
              setShowDescriptionIAModal(false)
              setCanAlert(true)

              // Notificação de sucesso
              Swal.fire({
                icon: 'success',
                title: 'Descrição gerada!',
                text: 'A descrição foi gerada com sucesso pela IA.',
                timer: 2000,
                showConfirmButton: false,
              })
            }}
            onCancel={() => setShowDescriptionIAModal(false)}
          />
        </ModalWrapper>
      )}
    </>
  )
}

const NewCriarProdutos: FC = () => {
  const {loginInfo} = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.product`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
          {
            title: i18n.t(`buttons.create`),
            path:
              loginInfo.plugintype === 'varejo' ? 'product_varejo/criar' : 'product_fashion/criar',
            isActive: true,
          },
        ]}
      >
        {`${i18n.t(`buttons.create`)} ${i18n.t(`smart_order.product`)}`}
      </PageTitle>
      <NewCriarProdutosContent />
    </>
  )
}

export {NewCriarProdutos}
